import * as Yup from 'yup'

interface ValidationMessages {
  company: string
  email: string
  general: string
  phone: string
}

export const validationSchema = (messages: ValidationMessages) =>
  Yup.object().shape({
    company: Yup.string().required(messages.company),
    Email: Yup.string().required(messages.email),
    Owner: Yup.string().required(messages.general),
    Phone: Yup.string().required(messages.phone),
  })
